import { Outlet, createFileRoute } from '@tanstack/react-router'

import { SubscriptionBanner } from '@/components/molecules/subscription-banner'

/**
 * Layout for the whole /documents subtree. The banner lives here rather than on each
 * page so the trial allowance and the read-only state are visible on the list, the
 * upload page and the combine wizard alike.
 */
const DocumentsLayout = () => (
  <div className="flex flex-col gap-4">
    <SubscriptionBanner />
    <Outlet />
  </div>
)

export const Route = createFileRoute('/_authenticated/documents')({
  component: DocumentsLayout,
})
